import { render, staticRenderFns } from "./CategoryCatalog.vue?vue&type=template&id=44ed7ff4&scoped=true&name=category-catalog&"
import script from "./CategoryCatalog.vue?vue&type=script&lang=js&"
export * from "./CategoryCatalog.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCatalog.vue?vue&type=style&index=0&id=44ed7ff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ed7ff4",
  null
  
)

export default component.exports